var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-section',{attrs:{"title":"氧减事件分布占比"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_c('div',{staticClass:"bar-chart",attrs:{"id":_vm.title}})])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }